import { useHistory } from 'react-router-dom';
import { useSiteContext, useTranslation } from '@eti/providers';
import { routes } from '../../constants/routesAndApisConstants';
import ErrorDialog from './ErrorDialog';

const SessionTimeoutDialog = () => {
  const { agencyAccount } = useSiteContext();
  const { t } = useTranslation();
  const history = useHistory();

  return (
    <ErrorDialog
      content={t('Payment.SessionTimeout.Description')}
      data-testid="session-timeout-dialog"
      isOpen
      onPrimaryAction={!agencyAccount ? () => history.push(routes.RESULT) : undefined}
      pictogramId="session-timeout"
      primaryButtonLabel={!agencyAccount ? t('Payment.SessionTimeout.Continue.Button') : undefined}
      title={t('Payment.SessionTimeout.Title')}
    />
  );
};

export default SessionTimeoutDialog;
